import * as React from 'react';
import styled, {css} from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import {Theme} from '../../../stores/AppStore';

export interface CategoryProps {
  icon: JSX.Element;
  onClick: () => void;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 92px;
  width: 70px;
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;

  ${({theme}) => {
    switch (theme.name) {
      case Theme.Dark: return css`
        color: ${theme.colors.white};
        border: 1px solid ${theme.variables.tableBorderColor};
        background-color: ${theme.variables.accentBackgroundColor};
     
        &:hover {
          background: ${transparentize(.95, theme.colors.white)};
        }

        &:active {
          background: ${({theme}) => transparentize(.90, theme.colors.white)};
        }
      `;
      case Theme.Light: return css`
        color: ${theme.colors.primary};
        border: 1px solid ${theme.variables.borderColor};
        background-color: ${theme.variables.accentBackgroundColor};
      `;
    }
  }};
  
  ${transition()};
`;

/**
 * The function render Category item
 * @param {CategoryProps} props
 * @constructor
 */
export default function Category(props: CategoryProps) {
  return (
    <Container onClick={props.onClick}>
      {props?.icon}
    </Container>
  );
}
